<template>
  <section class="pagination">
    <el-pagination
      background
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      :page-size="pageSize"
      :current-page="currentPage"
      :pager-count="pagerCount"
      @current-change="changePage"
      @prev-click="changePage"
      @next-click="changePage" 
      @size-change="handleSizeChange"
    ></el-pagination>
  </section>
</template>
<script>
export default {
  name: "pagination",
  data() {
    return {};
  },
  props: {
    total: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 20 //默认显示20条数据
    },
    currentPage: {
      type: Number,
      default: 1 //默认当前第一页
    },
    pagerCount: {
      type: Number,
      default: 7 //默认当前第一页
    }
  },
  methods: {
    changePage(e) {
      this.$emit("update:currentPage", e);
      this.$emit("getData");
      document.getElementsByClassName('el-table__body-wrapper')[0].scrollTop=0;
    },
    handleSizeChange(e){
       this.$emit("update:pageSize", e);
       this.$emit("getData");
       document.getElementsByClassName('el-table__body-wrapper')[0].scrollTop=0;
    }
  }
};
</script>
<style scoped>
  .pagination{
      text-align: right;
      padding: 20px 0;
  }
</style>>